import {Component} from 'react'
import {withRouter} from 'react-router-dom'
import Cookies from 'js-cookie'
import {formatDistanceToNow} from 'date-fns'
import ReactPlayer from 'react-player'
import Loader from 'react-loader-spinner'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'

import {BiLike, BiDislike} from 'react-icons/bi'
import {RiMenuAddLine} from 'react-icons/ri'

import Header from '../Header'
import Sidebar from '../Sidebar'

import ModeContext from '../../context/ModeContext'

import {
  DetailsContainer,
  DetailsTitle,
  ViewLikeCard,
  ViewsCard,
  LikesCard,
  LikesBtn,
  Hr,
  LogoCard,
  Logo,
  TextCard,
} from './styledComponents'

import {
  Flex,
  NoResults,
  NoRImg,
  NoR,
  NoRPara,
  RetryButton,
} from '../Home/styledComponents'

import './index.css'

const apiStatusConstants = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'IN_PROGRESS',
}

class VideoItemDetails extends Component {
  state = {
    videoDetails: {},
    isLiked: false,
    isDisliked: false,
    isSaved: false,
    apiStatus: apiStatusConstants.initial,
  }

  componentDidMount() {
    this.getVideoItemDetails()
  }

  getVideoItemDetails = async () => {
    this.setState({apiStatus: apiStatusConstants.inProgress})

    const {match} = this.props
    const {params} = match
    const {id} = params

    const jwtToken = Cookies.get('jwt_token')
    const url = `https://apis.ccbp.in/videos/${id}`
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
    const response = await fetch(url, options)

    if (response.ok) {
      const data = await response.json()
      const updatedData = {
        id: data.video_details.id,
        videoUrl: data.video_details.video_url,
        description: data.video_details.description,
        publishedAt: data.video_details.published_at,
        thumbnailUrl: data.video_details.thumbnail_url,
        title: data.video_details.title,
        viewCount: data.video_details.view_count,
        channel: {
          name: data.video_details.channel.name,
          profileImageUrl: data.video_details.channel.profile_image_url,
          subscriberCount: data.video_details.channel.subscriber_count,
        },
      }
      this.setState({
        videoDetails: updatedData,
        apiStatus: apiStatusConstants.success,
      })
    } else {
      this.setState({apiStatus: apiStatusConstants.failure})
    }
  }

  onClickRetry = () => {
    this.getVideoItemDetails()
  }

  onClickLike = () => {
    const {isDisliked} = this.state

    if (isDisliked) {
      this.setState({isLiked: true, isDisliked: false})
    } else {
      this.setState(prevState => ({isLiked: !prevState.isLiked}))
    }
  }

  onClickDislike = () => {
    const {isLiked} = this.state

    if (isLiked) {
      this.setState({isLiked: false, isDisliked: true})
    } else {
      this.setState(prevState => ({isDisliked: !prevState.isDisliked}))
    }
  }

  renderLoader = () => (
    <div className='loader-container' data-testid='loader'>
      <Loader type='ThreeDots' color='#ffffff' height='50' width='50' />
    </div>
  )

  renderFailure = () => (
    <ModeContext.Consumer>
      {value => {
        const {isDarkMode} = value
        const bg = isDarkMode ? '#0f0f0f' : '#f1f1f1'
        const color = isDarkMode ? 'white' : 'black'
        const src = isDarkMode
          ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-dark-theme-img.png'
          : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-failure-view-light-theme-img.png'

        return (
          <NoResults bg={bg}>
            <NoRImg failure src={src} alt='failure view' />
            <NoR color={color}>Oops! Something Went Wrong</NoR>
            <NoRPara>
              We are having some trouble to complete your request.
              <br />
              Please try again.
            </NoRPara>
            <RetryButton onClick={this.onClickRetry}>Retry</RetryButton>
          </NoResults>
        )
      }}
    </ModeContext.Consumer>
  )

  renderSuccess = () => {
    const {videoDetails, isLiked, isDisliked} = this.state
    const {id, title, videoUrl, channel, viewCount, publishedAt, description} =
      videoDetails
    const time = formatDistanceToNow(new Date(publishedAt))

    return (
      <ModeContext.Consumer>
        {value => {
          const {isDarkMode, savedVideos, addSaved, removeSaved} = value
          const isVideoSaved = savedVideos.some(each => id === each.id)

          const onClickSave = () => {
            if (isVideoSaved === false) {
              addSaved(videoDetails)
              this.setState(prevState => ({isSaved: !prevState.isSaved}))
            } else {
              removeSaved(id)
              this.setState(prevState => ({isSaved: !prevState.isSaved}))
            }
          }

          const bgColor = isDarkMode ? '#181818' : '#f9f9f9'
          const color = isDarkMode ? 'white' : '#212121'
          const colorP = isDarkMode ? '#64748b' : '#606060'
          const like = isLiked && 'active'
          const dislike = isDisliked && 'active'
          const save = isVideoSaved && 'active'
          const text = isVideoSaved ? 'Saved' : 'Save'

          return (
            <DetailsContainer bgColor={bgColor}>
              <ReactPlayer width='99%' height='50vh' url={videoUrl} controls />
              <DetailsTitle color={color}>{title}</DetailsTitle>
              <ViewLikeCard colorP={colorP}>
                <ViewsCard>
                  {viewCount} views • {time}
                </ViewsCard>
                <LikesCard>
                  <LikesBtn onClick={this.onClickLike}>
                    <BiLike className={`icon ${like}`} />{' '}
                    <span className={`icon ${like}`}>Like</span>
                  </LikesBtn>
                  <LikesBtn onClick={this.onClickDislike}>
                    <BiDislike className={`icon ${dislike}`} />{' '}
                    <span className={`icon ${dislike}`}>Dislike</span>
                  </LikesBtn>
                  <LikesBtn onClick={onClickSave}>
                    <RiMenuAddLine className={`icon ${save}`} />{' '}
                    <span className={`icon ${save}`}>{text}</span>
                  </LikesBtn>
                </LikesCard>
              </ViewLikeCard>
              <Hr />
              <LogoCard>
                <Logo src={channel.profileImageUrl} alt='channel logo' />
                <TextCard>
                  <DetailsTitle color={color}>{channel.name}</DetailsTitle>
                  <ViewsCard colorP={colorP}>
                    {channel.subscriberCount} Subscribers
                  </ViewsCard>
                  <ViewsCard mt color={color}>
                    {description}
                  </ViewsCard>
                </TextCard>
              </LogoCard>
            </DetailsContainer>
          )
        }}
      </ModeContext.Consumer>
    )
  }

  renderVideoItemDetails = () => {
    const {apiStatus} = this.state

    switch (apiStatus) {
      case apiStatusConstants.success:
        return this.renderSuccess()
      case apiStatusConstants.failure:
        return this.renderFailure()
      case apiStatusConstants.inProgress:
        return this.renderLoader()
      default:
        return null
    }
  }

  render() {
    return (
      <>
        <Header />
        <Flex>
          <Sidebar />
          {this.renderVideoItemDetails()}
        </Flex>
      </>
    )
  }
}

export default withRouter(VideoItemDetails)
